// extracted by mini-css-extract-plugin
module.exports = {"detailsWrapper":"_1cgo4"};